import { render, staticRenderFns } from "./ShowForm.vue?vue&type=template&id=0330a042"
import script from "./ShowForm.vue?vue&type=script&lang=js"
export * from "./ShowForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports